import { DateTime } from 'luxon'

import type { SeriesPageSession } from '@/common/services/seriesPage/types'

import type { SeriesStreakItem } from '@/components/Series/SeriesStreakBar/internal/types'

export default function getSeriesStreakItems(sessions: SeriesPageSession[]): SeriesStreakItem[] {
  return sessions.map(session => ({
    // didUserAttemptJoining(userId) for the viewer, which the payload resolves per row.
    attended: session.viewer.attemptedJoining,
    attendanceRequired: session.attendancePolicy === 'required',
    startDate: DateTime.fromISO(session.startDate),
    hasEnded: session.hasEnded,
  }))
}
